/**
 * sl-728o.7.3: Moderation Tutorial Session
 *
 * 3 steps guiding the user through moderation mode.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createModerationSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:moderation',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        // Moderation starts from the present control's menu.
        targetSelector: '[data-testid="detail-header-present-menu-button"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step1.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step1.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'bottom',
      },
      {
        // A running moderation takes over the control's main part.
        targetSelector: '[data-testid="detail-header-present-control"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step2.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step2.content'](),
        animation: 'highlight',
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetSelector: '[data-testid="detail-header-present-control"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step3.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step3.content'](),
        animation: 'none',
        trigger: { type: 'manual' },
        position: 'left',
      },
    ],
  };
}
